import type {UserSeatAssignment} from 'src/openapi/admin/models/UserSeatAssignment';

export type SeatAssignmentSortField = 'startDate' | 'endDate';
export type SeatAssignmentSortDirection = 'ASC' | 'DESC';

export const filterAndSortSeatAssignments = (
    assignments: UserSeatAssignment[],
    search: string,
    field: SeatAssignmentSortField,
    direction: SeatAssignmentSortDirection,
) => {
    const normalizedSearch = search.trim().toLowerCase();
    const multiplier = direction === 'ASC' ? 1 : -1;

    return assignments
        .filter(assignment => assignment.product.name.toLowerCase().includes(normalizedSearch))
        .sort((left, right) => multiplier * left[`subscription${field === 'startDate' ? 'Start' : 'End'}Date`]
            .localeCompare(right[`subscription${field === 'startDate' ? 'Start' : 'End'}Date`]));
};

export const paginateSeatAssignments = (assignments: UserSeatAssignment[], page: number, pageSize: number) => (
    assignments.slice((page - 1) * pageSize, page * pageSize)
);

export const getSummarySeatAssignments = (assignments: UserSeatAssignment[]) => assignments.slice(0, 5);
